module.exports = __webpack_public_path__ + "static/media/edit-icon-white.33fc9b23.svg";